import React from 'react';
import { PlayerStats as PlayerStatsType } from '../../../types';

interface PlayerStatsProps {
  stats: PlayerStatsType;
  hasPendingStats: boolean;
  statsTextColor: string;
  isMobile: boolean;
  isCompact: boolean;
  onValidateStats?: () => void;
  currentUserId?: string;
  playerUserId?: string;
}

export const PlayerStats: React.FC<PlayerStatsProps> = ({
  stats,
  hasPendingStats,
  statsTextColor,
  isMobile,
  isCompact,
  onValidateStats,
  currentUserId,
  playerUserId
}) => {
  const safeStats = stats || { goals: 0, assists: 0, saves: 0, votes: 0, votePercentage: 0 };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: isMobile || isCompact ? '12px' : '12px',
      marginTop: isMobile || isCompact ? '8px' : '0',
      fontSize: '14px',
      justifyContent: isMobile || isCompact ? 'flex-start' : 'flex-end',
      width: isMobile || isCompact ? '100%' : 'auto',
      flexWrap: 'wrap'
    }}>
      <div title="Goles" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: isMobile || isCompact ? '6px' : '4px', 
        minWidth: isMobile || isCompact ? '40px' : '32px',
        justifyContent: 'center'
      }}>
        <span style={{fontSize: '16px'}}>⚽</span>
        <span style={{
          fontWeight: 600, 
          color: hasPendingStats ? '#FF9800' : statsTextColor, 
          minWidth: isMobile || isCompact ? '12px' : '10px', 
          textAlign: 'center'
        }}>{safeStats.goals}</span>
      </div>
      <div title="Asistencias" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: isMobile || isCompact ? '6px' : '4px', 
        minWidth: isMobile || isCompact ? '40px' : '32px',
        justifyContent: 'center'
      }}>
        <span style={{fontSize: '16px'}}>➡️⚽</span>
        <span style={{
          fontWeight: 600, 
          color: hasPendingStats ? '#FF9800' : statsTextColor, 
          minWidth: isMobile || isCompact ? '12px' : '10px', 
          textAlign: 'center'
        }}>{safeStats.assists}</span>
      </div>
      <div title="Atajadas" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: isMobile || isCompact ? '6px' : '4px', 
        minWidth: isMobile || isCompact ? '40px' : '32px',
        justifyContent: 'center'
      }}>
        <span style={{fontSize: '16px'}}>🧤⚽</span>
        <span style={{
          fontWeight: 600, 
          color: hasPendingStats ? '#FF9800' : statsTextColor, 
          minWidth: isMobile || isCompact ? '12px' : '10px', 
          textAlign: 'center'
        }}>{safeStats.saves}</span>
      </div>
      
      {/* Botón validar stats */}
      {hasPendingStats && onValidateStats && currentUserId && playerUserId && playerUserId !== currentUserId && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onValidateStats();
          }}
          style={{
            background: '#2196F3',
            border: 'none',
            borderRadius: isMobile || isCompact ? '8px' : '6px',
            padding: isMobile || isCompact ? '4px 8px' : '6px 10px',
            color: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: isMobile || isCompact ? '10px' : '11px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            transition: 'background-color 0.2s',
            gap: '4px',
            height: 'fit-content',
            alignSelf: 'center'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1976D2';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#2196F3';
          }}
        >
          ✅ Valida mis stats!
        </button>
      )}
    </div>
  );
};
